export const imageExtensions = new Set(["jpg", "jpeg", "png", "gif"]);
export const videoExtensions = new Set(["mp4", "mkv", "avi", "mov"]);
export const BANNER_TYPES = {
  "CanalCorporativo-listadoBanners": {
    id: "2",
    id_tipo: "4",
    name: "Banner Vertical",
    list: "banners",
  },
  "CanalCorporativo-listadoBannersHorizontal": {
    id: "5",
    id_tipo: "5",
    name: "Banner Horizontal",
    list: "bannersH",
  },
  "CanalCorporativo-listadoBannersVerticalAAncho": {
    id: "8",
    id_tipo: "8",
    name: "Banner Vertical A - Ancho",
    list: "bannersVerticalAAncho",
  },
  "CanalCorporativo-listadoBannersVerticalBAncho": {
    id: "9",
    id_tipo: "9",
    name: "Banner Vertical B - Ancho",
    list: "bannersVerticalBAncho",
  },
  "CanalCorporativo-listadoBannersVerticalCAncho": {
    id: "10",
    id_tipo: "10",
    name: "Banner Vertical C - Ancho",
    list: "bannersVerticalCAncho",
  },
  "CanalCorporativo-listadoBannersVerticalAAlto": {
    id: "11",
    id_tipo: "11",
    name: "Banner Vertical A - Alto",
    list: "bannersVerticalAAlto",
  },
  "CanalCorporativo-listadoBannersVerticalBAlto": {
    id: "12",
    id_tipo: "12",
    name: "Banner Vertical B - Alto",
    list: "bannersVerticalBAlto",
  },
  "CanalCorporativo-listadoBannersVerticalCAlto": {
    id: "13",
    id_tipo: "13",
    name: "Banner Vertical C - Alto",
    list: "bannersVerticalCAlto",
  },
  "CanalCorporativo-listadoBannersHorizontalAlto": {
    id: "14",
    id_tipo: "14",
    name: "Banner Horizontal Alto",
    list: "bannersHorizontalAlto",
  },
  "CanalCorporativo-listadoBannersTresWidgets": {
    id: "15",
    id_tipo: "15",
    name: "Tres Widgets",
    list: "banners_tres_widgets",
  },
};

export const TYPES_NAME = {
  Videos: "1",
  Imagenes: "2",
  "Banners Verticales": "3",
  "Imagenes Mural": "4",
  "Videos Youtube": "5",
  "Banners L.Vertical Ancho": "6",
  "Banners L.Vertical Alto": "7",
};

export const tipoArchivoDetalleOptions = {
  "Video TV": "1",
  "Video CC": "2",
  Galeria: "3",
  Banners: "4",
  "Banners Horizontales": "5",
  "Banner Horizontal Alto": "14",
  "Tres Widgets": "15",
  "Imagen CC": "6",
  "Videos Youtube": "7",
  "Banner Vertical A - Ancho": "8",
  "Banner Vertical B - Ancho": "9",
  "Banner Vertical C - Ancho": "10",
  "Banner Vertical A - Alto": "11",
  "Banner Vertical B - Alto": "12",
  "Banner Vertical C - Alto": "13",
};
/*
cc_tipo_archivo
id value type text
0	0	video	Videos
3	3	image	Imágenes
2	2	externo	Videos de YouTube
1	1	video	Módulo Videos
5	4	link_powerbi	Enlace Power BI
*/
/*
archivo_tipo
1	Videos
2	Imagenes
3	Banners Verticales
4	Imagenes Mural
5	Videos Youtube
6	Banners L.Vertical Ancho
7	Banners L.Vertical Alto
8	Archivos Builder
9	Links Power BI
*/
/*
archivo_modulo_fk
2	Video CC
4	Banners
5	Banners Horizontales
6	Imagen CC
7	Videos Youtube
8	Banner Vertical A - Ancho
9	Banner Vertical B - Ancho
10	Banner Vertical C - Ancho
13	Banner Vertical C - Alto
11	Banner Vertical A - Alto
12	Banner Vertical B - Alto
14	Banner Horizontal Alto
15	Banner Vertical D
19	Links Power BI
*/
export const typesDescHash = {
  1: 1,
  2: 1,
  3: 2,
  5: 3,
  6: 4,
  7: 5,
  8: 6,
  9: 6,
  10: 6,
  11: 7,
  12: 7,
  13: 7,
  19: 8
};

export const DEFAULT_LOGO_URL =
  "https://storage.googleapis.com/c3-bucket-01/iconos_administrador/transparente_10x10.png";
export const DEFAULT_LOGO_STATE = {
  base64: DEFAULT_LOGO_URL,
  src: DEFAULT_LOGO_URL,
  width: 10,
  height: 10,
  format: "png",
};

export const DAYS = {
  1: {id: 1, char:'L' ,name:"Lunes"},
  2: {id: 2, char:'M' ,name:"Martes"},
  3: {id: 3, char:'X' ,name:"Miércoles"},
  4: {id: 4, char:'J' ,name:"Jueves"},
  5: {id: 5, char:'V' ,name:"Viernes"},
  6: {id: 6, char:'S' ,name:"Sábado"},
  7: {id: 7, char:'D' ,name:"Domingo"},
};
export const N_LAYOUT_WIDGETS = {
  1: 4,
  2: 4,
  3: 2,
  11: 2,
  13: 3,
};

export const N_LAYOUT_BANNERS = {
  1:  [{name: "banners"}],
  2:  [{ name: "banners" }],
  4:  [{ name: "bannersHorizontalAlto" }, { name: "bannersH" }],
  5:  [{ name: "bannersHorizontalAlto" }],
  8:  [{ name: "bannersVerticalAAncho" }],
  9:  [{ name: "bannersVerticalAAncho" }, { name: "bannersVerticalBAncho" }],
  10: [{ name: "bannersVerticalAAncho" }, { name: "bannersVerticalCAncho" }],
  11: [{ name: "bannersVerticalAAlto" }],
  12: [{ name: "bannersVerticalBAlto" },  { name: "bannersVerticalCAlto" }],
  13: [{ name: "banners_tres_widgets" }],
};
export const ROUTES_DESTROY_BYPASS = [
  "CanalCorporativo-addContenido",
  "CanalCorporativo-editContenido",
  "CanalCorporativo-editFirstContenido",
  "CanalCorporativo-listadoVideos",
  "CanalCorporativo-listadoBanners",
  "CanalCorporativo-listadoBannersHorizontal",
  "CanalCorporativo-listadoBannersVerticalAAncho",
  "CanalCorporativo-listadoBannersVerticalBAncho",
  "CanalCorporativo-listadoBannersVerticalCAncho",
  "CanalCorporativo-listadoBannersVerticalAAlto",
  "CanalCorporativo-listadoBannersVerticalBAlto",
  "CanalCorporativo-listadoBannersVerticalCAlto",
  "CanalCorporativo-listadoBannersHorizontalAlto",
  "CanalCorporativo-listadoBannersTresWidgets",
];
